import React, { useEffect, useRef } from "react";
import "./payCalculation.css";
import { calculateTalentNetPay } from "./utils";
import CloseIcon from "../../../../../../assets/icons/CloseIcon.svg";

const PayCalculation = ({ amount, isPrivateGig, onClose, ProfessionCode, taxTerm, SourceId }) => {
  // const skillGigPercentage = isPrivateGig ? 10 : 20;
  const skillGigPercentage = 10;
  const payrollCostPercentage = ProfessionCode != "HC" && taxTerm != "W-2" && (SourceId != 1 || taxTerm == "1099/Corp-to-Corp") ? 5 : 18;
  const { skillGiggFee, payrollCost, netGrossPay, grossPay } =
    calculateTalentNetPay({
      amount,
      skillGigPercentage,
      payrollCostPercentage,
    });

    const tooltipRef = useRef(null);

    const handleClose = (event) => {
      if (tooltipRef.current) {
        tooltipRef.current.setPopupVisible(false);
      }
      event.stopPropagation();
      onClose();
    };

    useEffect(() => {
      const handleKeyDown = (event) => {
        if (event.key === "Escape") {
          onClose();
        }
      };
  
      document.addEventListener("keydown", handleKeyDown);
  
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }, [onClose]);

  return (
    <div className="wrapper-div-new">
      <div className="grid-container-new">
        <div className="grid-container1-new grid-first-item-new">
          <div className="grid-item1-new grid-item1-new-transparency">SkillGigs Pricing Transparency</div>
          <div className="grid-item2-new">
            <img onClick={handleClose} src={CloseIcon} alt="close-icon"/>
          </div>
        </div>
        <div className="grid-container1-new">
          <div className="grid-item1-new">Final bill rate</div>
          <strong className="grid-item2-new">${amount}</strong>
        </div>
        <div className="grid-container1-new">
          <div className="grid-item1-new">SkillGigs fees ({skillGigPercentage}%)</div>
          <div className="grid-item2-new">
            (${parseFloat(skillGiggFee).toFixed(2)})
          </div>
        </div>
        <div className="grid-container1-new total-gross-pay">
          <div className="grid-item1-new">Talent gross pay</div>
          <strong className="grid-item2-new">
            ${parseFloat(grossPay).toFixed(2)}
          </strong>
        </div>
        <div className="grid-container1-new">
          <div className="grid-item1-new">Payroll cost to talent ({payrollCostPercentage}%)</div>
          <div className="grid-item2-new">
            (${parseFloat(payrollCost).toFixed(2)})
          </div>
        </div>
        <div className="grid-container1-new grid-last-item-new total-net-pay">
          <strong className="grid-item1-new">Talent net pay</strong>
          <strong className="grid-item2-new">
            ${parseFloat(netGrossPay).toFixed(2)}
          </strong>
        </div>
      </div>
    </div>
  );
};

export default PayCalculation;
